export default __webpack_public_path__ + "static/media/oprah_winfrey_2.1c471f03.jpg";